import { createRouter, createWebHistory } from 'vue-router'
import app_Downloads from '@/components/App_Downloads'
import homeIndex from '@/components/homeIndex'
import securityIndex from '@/components/securityIndex'
import walletIndex from '@/components/walletIndex'
import supportIndex from '@/components/supportIndex'
import dappIndex from '@/components/dappIndex'
import stakingIndex from '@/components/stakingIndex'
import blogIndex from '@/components/blogIndex'
import aboutIndex from '@/components/aboutIndex'
import faqIndex from '@/components/faqIndex'
import walletMenuIndex from '@/components/walletMenuIndex'
import docsIndex from '@/components/docsIndex'
import brandIndex from '@/components/brandIndex'
import walletMenuEvmIndex from '@/components/walletMenuEvmIndex'
import walletMenuLayer2Index from '@/components/walletMenuLayer2Index'
import contactIndex from '@/components/contactIndex'

//Pc
import homePcIndex from '@/componentsPc/homePcIndex'
import supportPcIndex from '@/componentsPc/supportPcIndex'
import downloadsPcIndex from '@/componentsPc/downloadsPcIndex'
import blogPcIndex from '@/componentsPc/blogPcIndex'
import stakingPcIndex from '@/componentsPc/stakingPcIndex'
import walletPcIndex from '@/componentsPc/walletPcIndex'
import dappPcIndex from '@/componentsPc/dappPcIndex'
import walletMenuLayer2PcIndex from '@/componentsPc/walletMenuLayer2PcIndex'
import docsPcIndex from '@/componentsPc/docsPcIndex'
import aboutPcIndex from '@/componentsPc/aboutPcIndex'
import brandPcIndex from '@/componentsPc/brandPcIndex'
import securityPcIndex from '@/componentsPc/securityPcIndex'
import faqPcIndex from '@/componentsPc/faqPcIndex'
import walletMenuEvmPcIndex from '@/componentsPc/walletMenuEvmPcIndex'
import walletMenuPcIndex from '@/componentsPc/walletMenuPcIndex'

let routes
if (isMobileDevice()) {
  routes = [
    {
      path: '/download',
      component: app_Downloads,
    },
    {
      path: '/',
      component: homeIndex,
    },
    {
      path: '/security',
      component: securityIndex,
    },
    {
      path: '/wallet',
      component: walletIndex,
    },
    {
      path: '/support',
      component: supportIndex,
    },
    {
      path: '/dapp',
      component: dappIndex,
    },
    {
      path: '/staking',
      component: stakingIndex,
    },
    {
      path: '/blog',
      component: blogIndex,
    },
    {
      path: '/about',
      component: aboutIndex,
    },
    {
      path: '/faq',
      component: faqIndex,
    },
    {
      path: '/public-chain-wallet-menu',
      component: walletMenuIndex,
    },
    {
      path: '/docs',
      component: docsIndex,
    },
    {
      path: '/brand',
      component: brandIndex,
    },
    {
      path: '/evm-chain-wallet-menu',
      component: walletMenuEvmIndex,
    },
    {
      path: '/layer2-wallet-menu',
      component: walletMenuLayer2Index,
    },
    {
      path: '/contact',
      component: contactIndex,
    },
  ]
} else {
  routes = [
    {
      path: '/',
      component: homePcIndex,
    },
    {
      path: '/support',
      component: supportPcIndex,
    },
    {
      path: '/download',
      component: downloadsPcIndex,
    },
    {
      path: '/blog',
      component: blogPcIndex,
    },
    {
      path: '/staking',
      component: stakingPcIndex,
    },
    {
      path: '/wallet',
      component: walletPcIndex,
    },
    {
      path: '/dapp',
      component: dappPcIndex,
    },
    {
      path: '/layer2-wallet-menu',
      component: walletMenuLayer2PcIndex,
    },
    {
      path: '/docs',
      component: docsPcIndex,
    },
    {
      path: '/about',
      component: aboutPcIndex,
    },
    {
      path: '/brand',
      component: brandPcIndex,
    },
    {
      path: '/security',
      component: securityPcIndex,
    },
    {
      path: '/faq',
      component: faqPcIndex,
    },
    {
      path: '/evm-chain-wallet-menu',
      component: walletMenuEvmPcIndex,
    },
    {
      path: '/public-chain-wallet-menu',
      component: walletMenuPcIndex,
    },
    // Add desktop-specific routes here...
  ]
}

const routerHistory = createWebHistory()

const router = createRouter({
  history: routerHistory,
  routes,
})

function isMobileDevice() {
  // 根据 User Agent 或其他条件判断是否为移动设备
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )
}

export default router
